// The modalities page's category selector, kept in the URL so a scoped
// view survives opening a class and coming back, and can be shared.
export const CATEGORY_PARAM = 'categoria'
// Selector value for modalities without a category.
export const UNCATEGORIZED = 'sem'

/**
 * The value the backend expects for the selected category: its id, or
 * `null` (read as "no category" by the generic list API, the class KPIs and
 * the attendance print) for `UNCATEGORIZED`. `undefined` when no category
 * is selected, so the param is left out.
 */
export const categoryParam = (category) => {
  if (!category) return undefined
  return category === UNCATEGORIZED ? 'null' : category
}
